import { Select } from "antd";
import { useEffect, useState } from "react";
import { dropdownCustom } from "../select/SelectOption";

export default function SelectSearch({
  onChange,
  onScroll,
  onSelect,
  options,
  width,
  keyword,
  placeholder = "",
  defaultValue = null,
  disabled = false,
  status = "",
  size = "medium",
  value,
}) {
  const [dropdownOptions, setDropdownOptions] = useState([]);

  useEffect(() => {
    setDropdownOptions(
      options?.map((item) => ({
        value: item.id,
        label: item.value,
      }))
    );
  }, [options]);

  return (
    <div>
      <Select
        defaultValue={defaultValue !== "" ? defaultValue : null}
        placeholder={placeholder}
        value={value}
        size={size}
        onSelect={(id, val) => onSelect(id, val)}
        options={dropdownOptions}
        style={{ width }}
        status={status}
        onPopupScroll={(e) => onScroll(e)}
        disabled={disabled}
        dropdownRender={(menu) =>
          dropdownCustom(menu, (value) => onChange(value.target.value), keyword)
        }
      />
    </div>
  );
}
